import Vue from 'vue';

export default {
	addNotification({}: any, notificationString: any) {
		Vue.notify({
			group: 'ally',
			text: notificationString,
			duration: 5000,
		});
	},
};
